export default __webpack_public_path__ + "static/media/Transparent_Blue_Glow.14dd97db.png";